import * as React from 'react';

function SvgSkipEndCircleFill(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='1em'
			height='1em'
			fill='currentColor'
			className='svg-icon'
			viewBox='0 0 16 16'
			{...props}>
			<path d='M16 8A8 8 0 110 8a8 8 0 0116 0zM6.79 5.093A.5.5 0 006 5.5v5a.5.5 0 00.79.407L9.5 8.972V10.5a.5.5 0 001 0v-5a.5.5 0 00-1 0v1.528L6.79 5.093z' />
		</svg>
	);
}

export default SvgSkipEndCircleFill;
